module.exports = __webpack_public_path__ + "img/74d1a7b.png";